import { render, staticRenderFns } from "./componentsDemo.vue?vue&type=template&id=19bac56a&scoped=true&"
import script from "./componentsDemo.vue?vue&type=script&lang=js&"
export * from "./componentsDemo.vue?vue&type=script&lang=js&"
import style0 from "./componentsDemo.vue?vue&type=style&index=0&id=19bac56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bac56a",
  null
  
)

export default component.exports